import { type SurfaceTone, toneText } from '@workspace/ui/lib/tone'
import { cn } from '@workspace/ui/lib/utils'
import type { ReactNode } from 'react'

export interface EyebrowProps {
  children: ReactNode
  /**
   * Kept as a tone rather than a colour so the treatment stays consistent
   * across the eyebrow, the headline accent and the card border. See
   * SurfaceTone for what each one means.
   */
  tone?: SurfaceTone
  className?: string
}

/** Small uppercase label above a headline. */
export function Eyebrow({ children, tone = 'default', className }: EyebrowProps) {
  return (
    <div
      data-slot="eyebrow"
      className={cn(
        'text-[11px] font-semibold uppercase tracking-[0.16em]',
        toneText(tone),
        className
      )}
    >
      {children}
    </div>
  )
}
